/* tslint:disable */
/* eslint-disable */
/**
 * Borrower API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { LoanTierDto } from './LoanTierDto';
import {
    LoanTierDtoFromJSON,
    LoanTierDtoFromJSONTyped,
    LoanTierDtoToJSON,
    LoanTierDtoToJSONTyped,
} from './LoanTierDto';

/**
 * 
 * @export
 * @interface UpdateLoanDto
 */
export interface UpdateLoanDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateLoanDto
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateLoanDto
     */
    riskId?: string;
    /**
     * 
     * @type {number}
     * @memberof UpdateLoanDto
     */
    loanAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateLoanDto
     */
    totalDuration?: number;
    /**
     * 
     * @type {string}
     * @memberof UpdateLoanDto
     */
    interestRateTypeId?: string;
    /**
     * 
     * @type {number}
     * @memberof UpdateLoanDto
     */
    interestRatePercentage?: number;
    /**
     * 
     * @type {string}
     * @memberof UpdateLoanDto
     */
    loanTypeId?: string;
    /**
     * 
     * @type {number}
     * @memberof UpdateLoanDto
     */
    defermentPeriod?: number;
    /**
     * 
     * @type {string}
     * @memberof UpdateLoanDto
     */
    defermentTypeId?: string;
    /**
     * 
     * @type {number}
     * @memberof UpdateLoanDto
     */
    insuranceAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateLoanDto
     */
    quota?: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateLoanDto
     */
    deductible?: number;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateLoanDto
     */
    isCapital?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateLoanDto
     */
    isPsyBuyback?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateLoanDto
     */
    isContribExempt?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateLoanDto
     */
    guaranteeIds?: Array<string>;
    /**
     * Loan tiers (full replacement). Omit to leave tiers unchanged.
     * @type {Array<LoanTierDto>}
     * @memberof UpdateLoanDto
     */
    tiers?: Array<LoanTierDto>;
}

/**
 * Check if a given object implements the UpdateLoanDto interface.
 */
export function instanceOfUpdateLoanDto(value: object): value is UpdateLoanDto {
    return true;
}

export function UpdateLoanDtoFromJSON(json: any): UpdateLoanDto {
    return UpdateLoanDtoFromJSONTyped(json, false);
}

export function UpdateLoanDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateLoanDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'riskId': json['riskId'] == null ? undefined : json['riskId'],
        'loanAmount': json['loanAmount'] == null ? undefined : json['loanAmount'],
        'totalDuration': json['totalDuration'] == null ? undefined : json['totalDuration'],
        'interestRateTypeId': json['interestRateTypeId'] == null ? undefined : json['interestRateTypeId'],
        'interestRatePercentage': json['interestRatePercentage'] == null ? undefined : json['interestRatePercentage'],
        'loanTypeId': json['loanTypeId'] == null ? undefined : json['loanTypeId'],
        'defermentPeriod': json['defermentPeriod'] == null ? undefined : json['defermentPeriod'],
        'defermentTypeId': json['defermentTypeId'] == null ? undefined : json['defermentTypeId'],
        'insuranceAmount': json['insuranceAmount'] == null ? undefined : json['insuranceAmount'],
        'quota': json['quota'] == null ? undefined : json['quota'],
        'deductible': json['deductible'] == null ? undefined : json['deductible'],
        'isCapital': json['isCapital'] == null ? undefined : json['isCapital'],
        'isPsyBuyback': json['isPsyBuyback'] == null ? undefined : json['isPsyBuyback'],
        'isContribExempt': json['isContribExempt'] == null ? undefined : json['isContribExempt'],
        'guaranteeIds': json['guaranteeIds'] == null ? undefined : json['guaranteeIds'],
        'tiers': json['tiers'] == null ? undefined : ((json['tiers'] as Array<any>).map(LoanTierDtoFromJSON)),
    };
}

export function UpdateLoanDtoToJSON(json: any): UpdateLoanDto {
    return UpdateLoanDtoToJSONTyped(json, false);
}

export function UpdateLoanDtoToJSONTyped(value?: UpdateLoanDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'riskId': value['riskId'],
        'loanAmount': value['loanAmount'],
        'totalDuration': value['totalDuration'],
        'interestRateTypeId': value['interestRateTypeId'],
        'interestRatePercentage': value['interestRatePercentage'],
        'loanTypeId': value['loanTypeId'],
        'defermentPeriod': value['defermentPeriod'],
        'defermentTypeId': value['defermentTypeId'],
        'insuranceAmount': value['insuranceAmount'],
        'quota': value['quota'],
        'deductible': value['deductible'],
        'isCapital': value['isCapital'],
        'isPsyBuyback': value['isPsyBuyback'],
        'isContribExempt': value['isContribExempt'],
        'guaranteeIds': value['guaranteeIds'],
        'tiers': value['tiers'] == null ? undefined : ((value['tiers'] as Array<any>).map(LoanTierDtoToJSON)),
    };
}

